/**
 * RISK-DELETE.MODAL
 * Ask for deleting risk
 * If older risk this will be archived
 */

import Modal from "@/components/modal"
import EnterCodeWidget from "@/widgets/enter-code.widget"
import { useAppSelector } from "@/core/root-reducer"
import { t } from "i18next"
import unitStore from "../../model/unit.store"
import { useUnitEditModal } from "../../hooks/useUnitEditModal"
import { useNavigate } from "react-router-dom"
import riskStore from "../../../risk/model/risk.store"
import Space from "@/components/space"
import { groupBy } from "lodash"

interface Props {
  onClose: Function
}

export default function UnitDeleteModal(props: Props) {
  const navigate = useNavigate()

  const status = useAppSelector(unitStore.selectors.status)
  const unit = useAppSelector(unitStore.selectors.draft)
  const units = useAppSelector(unitStore.selectors.list)
  const risks = useAppSelector(riskStore.selectors.list)

  const { confirmDelete } = useUnitEditModal(units, unit)
  const relatedRisks = risks.filter((r) => r.UnitId === unit.id)

  async function next() {
    await confirmDelete()
    navigate("/risks/units")
  }

  return (
    <Modal
      onClose={() => props.onClose()}
      title={`Supprimer l’unité “${unit.name}”`}
      footer={<EnterCodeWidget onCancel={() => props.onClose()} onNext={next} status={status} />}>
      <div className="space-y-4 text-neutral-800">
        <p>
          <b>{t("units_utils_ask_save", { name: unit.name })}&nbsp;</b>
        </p>

        {relatedRisks.length > 0 ? (
          <>
            <p className="red-t">
              <b>
                {relatedRisks.length === 1
                  ? `Le risque suivant lié à cette unité sera archivé.`
                  : `Les ${relatedRisks.length} risques suivants liés à cette unité seront archivés`}
              </b>
            </p>
            <div className="space-y-3 max-h-[200px] overflow-auto">
              {Object.entries(groupBy(relatedRisks, "name")).map(([riskName, risks]) => (
                <div key={riskName} className="text-sm p-2 bg-red-50 rounded grey-t space-y-1">
                  <div>
                    <b>{riskName}</b>
                  </div>
                  {risks.map((risk) => (
                    <div key={risk.id} className="ml-2 italic">
                      {Object.values(risk.attributes)[1]}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </>
        ) : (
          <p className="text-sm italic grey-t">{t("Aucun risque lié à cette unité ni à ses sous-unités.")}</p>
        )}

        <Space />
      </div>
    </Modal>
  )
}
